export const buildVersion = { version: 'CombiPlus_develop_20261105.1' };
